"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("./Icon"));
require("./style.scss");
var SvgIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 64 : _b, _c = _a.height, height = _c === void 0 ? 64 : _c, className = _a.className, name = _a.name;
    var icon = Icon_1.default.find(function (item) { return item.name === name; }), Component = icon === null || icon === void 0 ? void 0 : icon.icon;
    return Component ? (react_1.default.createElement(Component, { className: className, height: height, width: width })) : null;
};
exports.default = SvgIcon;
